import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { toast } from "react-toastify";
import { ReactComponent as PointIcon } from "../../assets/icon/money-finance.svg";
import ConditionalRender from "../../components/Common/ConditionalRender";

function ListPoint() {
    const isLogin = localStorage.getItem("isLogin");
    const isProfile = localStorage.getItem("isProfile");
    const parseLogin = JSON.parse(isLogin);
    const profileData = JSON.parse(isProfile);
    const [listMemberData, setListMemberData] = useState([]);

    const [listMemberLoading, setListMemberLoading] = useState(true);

    const [point, setPoint] = useState(0);
    const [itemsPerPage] = useState(6);
    const [currentPage, setCurrentPage] = useState(0);


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(isIdTarget(undefined));
    }, [dispatch]);


    useEffect(() => {
        if (isLogin) {
            const parseLogin = JSON.parse(isLogin);
            fetchListgiftCard(parseLogin?.apiKey, parseLogin?.token);
        }
    }, [currentPage]);


    const fetchListgiftCard = async (api_key, token) => {
        setListMemberLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("api_key", api_key);
            params.append("limit", itemsPerPage);
            params.append("page", currentPage);

            const response = await ApiService({
                baseurl: "user/listTukarPoint",
                parameter: "api_key=" + api_key,
                method: "POST",
                XGORDON: "LISTTUKARPOINT",
                apiKey: api_key,
                token: token,
                body: params,
            });
            setListMemberLoading(false);
            if (response?.statusCode === 200) {
                setListMemberData(response.result.data);
                setPoint(response.result.pointku)
            } else {
                setListMemberData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const cekPoin = async (id) => {
        try {
            const params = new URLSearchParams();
            params.append("api_key", parseLogin?.apiKey);
            params.append("id", id);

            const response = await ApiService({
                baseurl: "user/tukar",
                method: "POST",
                XGORDON: "TUKAR",
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,
                body: params,
            });
            if (response?.statusCode === 200) {
                toast.success(response.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(response.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleNextPage = () => {
        setCurrentPage((halamanSebelumnya) => halamanSebelumnya + itemsPerPage);
    };

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage((halamanSebelumnya) => halamanSebelumnya - itemsPerPage);
        }
    };

    return (
        <div className="flex flex-col gap-3 flex-1">
            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-3xl  text-[#22BDE2] font-bold">Tukar Poin</span>
                    <span className=" text-base font-light ">Halaman ini untuk menukarkan poin akun anda, kumpulkan poin sebanyak mungkin dan tukarkan dengan saldo Yokcash!
                    </span>
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/pngwing 5.png')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 h-60 " />
                </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 px-3 flex-1 ">
                <div className="flex flex-col flex-1">
                    <div className="flex flex-col lg:rounded-lg shadow-inner p-3 rounded-md overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                        <div className=" pb-3 border-b border-[#f3f3f3] flex flex-col justify-center">
                            <span className="text-lg opacity-50 font-medium line-clamp-1">
                                Poin Saya
                            </span>
                            <span className=" text-2xl font-bold line-clamp-1">
                                {point} Pts
                            </span>
                        </div>
                        <div className="flex flex-col pt-3">
                            <span className="text-lg font-semibold line-clamp-1 mb-2">
                                Cara Tukar Point
                            </span>
                            <span className="text-sm opacity-60 line-clamp-1">
                                1. Kumpulkan Poin Sebanyak mungkin
                            </span>
                            <span className="text-sm opacity-60 line-clamp-1">
                                2. Pilih Item Penukaran sesuai jumlah Poin
                            </span>
                            <span className="text-sm opacity-60 line-clamp-1">
                                3. Selesaikan Penukaran
                            </span>
                            <span className="text-sm opacity-60 line-clamp-1">
                                4. Cek Penukaran telah Berhasil
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col basis-7/12  rounded-lg shadow-inner  bg-cardLight dark:bg-cardDark  min-h-[300px]">
                    <div className="flex flex-col gap-1 rounded-tl-md  bg-[#22BDE2] rounded-tr-md p-3">
                        <span className="text-[#ffffff] text-base font-medium line-clamp-1">
                            Tukar Point
                        </span>
                    </div>
                    <ConditionalRender
                        productsData={listMemberData}
                        isLoading={listMemberLoading}
                        model={"emptyData"}
                    >
                        <div className="grid grid-cols-1 xl:grid-cols-3 sm:grid-cols-2 gap-2 p-3 ">
                            {listMemberData.map((item, index) => (
                                <div key={index}
                                    className="flex flex-col p-2.5 bg-lightColor shadow-inner gap-2 dark:bg-darkColor rounded-lg overflow-hidden"
                                >
                                    <img
                                        src={item.gambar}
                                        alt={`${item.gambar} logo`}
                                        className="w-full object-cover aspect-[2.5/1] rounded-md "
                                    />
                                    <div className="flex flex-col gap-2 flex-1">
                                        <span className=" text-sm font-medium ">
                                            {item.judul}
                                        </span>
                                        <span className=" text-xs  ">
                                            {item.deskripsi}
                                        </span>
                                        <div className="flex flex-row gap-1 items-center flex-1 ">
                                            <PointIcon className="h-3 w-3" fill="#22BDE2" />
                                            <span className="text-sm  font-bold line-clamp-1">
                                                {item.harga_tukar} Point
                                            </span>
                                        </div>
                                        <Button
                                            initialValue=" Tukar Point"
                                            type="fill"
                                            className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor text-xs h-8 w-full"
                                            onClick={() => {
                                                cekPoin(item.id);
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ConditionalRender>
                    <div className="p-3 w-full flex flex-row gap-2 justify-center">
                        <Button
                            disabled={currentPage <= 0}
                            initialValue="Sebelumnya"
                            type="fill"
                            className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${currentPage <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => { handlePreviousPage() }}
                        />
                        <Button
                            disabled={listMemberData.length === 0}
                            initialValue="Selanjutnya"
                            type="fill"
                            className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${listMemberData.length <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => handleNextPage()}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ListPoint;
